import React from 'react'
import { Col, Row } from 'antd';
import moment from 'moment/moment';
import SelectOption from '../../../../../components/atoms/formFields/selectOption';
import { ContentInputField } from '../../../../../components/atoms/formFields/inputField/contentInputField';
import FormRepeater from './FormRepeater';
import { AllRangePicker } from '../../../../../components/atoms/formFields/rangePicker/allRangePicker';

const SeedDetail = ({ detail }) => {
    return (
        <>
            <div className="separator separator-solid my-5"></div>
            <Row gutter={[12, 12]}>
                <Col xs={24}>
                    <h6 className="font-weight-bolder">
                        Seed Details
                    </h6>
                </Col>
                <Col xs={12} lg={8}>
                    <label className="font-weight-bolder font-size-md">
                        Sowing Time
                    </label>
                    {detail?.productDetails?.sowingTime?.map(
                        (time, index) => {
                            return (
                                <AllRangePicker
                                    key={index.toString()}
                                    disabled
                                    value={[
                                        time?.startTime &&
                                        moment(
                                            time?.startTime,
                                            "YYYY-MM-DD"
                                        ),
                                        time?.endTime &&
                                        moment(
                                            time?.endTime,
                                            "YYYY-MM-DD"
                                        ),
                                    ]}
                                    format={"DD MMM, YYYY"}
                                />
                            );
                        }
                    )}
                </Col>

                <Col
                    className="gutter-row"
                    xs={24}
                    lg={8}
                >
                    <SelectOption
                        placeholder="Crop Seasons"
                        isDisabled={true}
                        isMulti={true}
                        value={detail?.productDetails?.cropSeasons?.map(
                            (season) => {
                                return {
                                    label: season?.en,
                                    value: season?.en,
                                };
                            }
                        )}
                    />
                </Col>

                <Col
                    className="gutter-row"
                    xs={24}
                    lg={8}
                >
                    <ContentInputField
                        name="Seed Type"
                        isDisabled
                    value={detail?.productDetails?.seedType?.en}
                    />
                </Col>
                <Col
                    className="gutter-row"
                    xs={24}
                    lg={8}
                >
                    <ContentInputField
                        name="Seed Class"
                        isDisabled
                    value={detail?.productDetails?.seedClass?.en}
                    />
                </Col>

                <Col
                    className="gutter-row"
                    xs={24}
                    lg={8}
                >
                    <SelectOption
                        placeholder="States"
                        isDisabled={true}
                        isMulti={true}
                        value={detail?.productDetails?.states?.map(
                            (inner) => {
                                return {
                                    label: inner?.en,
                                    value: inner?.en,
                                };
                            }
                        )}
                    />
                </Col>

                <Col
                    className="gutter-row"
                    xs={24}
                    lg={8}
                >
                    <ContentInputField
                        name="Crop Durations"
                        isDisabled
                        value={detail?.productDetails?.duration?.en}
                    />
                </Col>

                <Col
                    className="gutter-row"
                    xs={24}
                    lg={8}
                >
                    <SelectOption
                        placeholder="Soils"
                        isDisabled={true}
                        isMulti={true}
                        value={detail?.productDetails?.soils?.map(
                            (inner) => {
                                return {
                                    label: inner?.en,
                                    value: inner?.en,
                                };
                            }
                        )}
                    />
                </Col>

                <Col
                    className="gutter-row"
                    xs={24}
                    lg={8}
                >
                    <SelectOption
                        className="w-100 font-size-sm"
                        placeholder="Sowing Methods"
                        isDisabled={true}
                        isMulti={true}
                        value={detail?.productDetails?.sowingMethods?.map(
                            (inner) => {
                                return {
                                    label: inner?.en,
                                    value: inner?.en,
                                };
                            }
                        )}
                    />
                </Col>
                <Col
                    className="gutter-row"
                    xs={24}
                    lg={12}
                >
                    <label className="font-weight-bolder font-size-md m-0">
                        Crop Height
                    </label>
                    <FormRepeater type="cropHeight" value={detail?.productDetails?.cropHeight} disabled={true} />
                </Col>

                <Col
                    className="gutter-row"
                    xs={24}
                    lg={12}
                >
                    <label className="font-weight-bolder font-size-md m-0">
                        Average Yield
                    </label>
                    <FormRepeater type="averageYield" value={detail?.productDetails?.averageYield} disabled={true} />
                </Col>

                <Col
                    className="gutter-row"
                    xs={24}
                    lg={12}
                >
                    <label className="font-weight-bolder font-size-md m-0">
                        Fruit Weight
                    </label>
                    <FormRepeater type="fruitWeight" value={detail?.productDetails?.fruitWeight} disabled={true} />
                </Col>

                <Col
                    className="gutter-row"
                    xs={24}
                    lg={12}
                >
                    <label className="font-weight-bolder font-size-md m-0">
                        Maturity
                    </label>
                    <FormRepeater type="maturity" value={detail?.productDetails?.maturity} disabled={true} />
                </Col>

                <Col
                    className="gutter-row"
                    xs={24}
                    lg={12}
                >
                    <label className="font-weight-bolder font-size-md m-0">
                        Seed Rate
                    </label>
                    <FormRepeater type="seedRate" value={detail?.productDetails?.seedRate} disabled={true} />
                </Col>

                <Col
                    className="gutter-row"
                    xs={24}
                    lg={12}
                >
                    <label className="font-weight-bolder font-size-md m-0">
                        Land Area
                    </label>
                    <Row
                        gutter={[12, 12]}
                        className="align-items-center"
                    >
                        <Col xs={12}>
                            <ContentInputField
                                name="Area"
                                filter={true}
                                value={
                                    detail?.productDetails?.landArea
                                        ?.area
                                }
                                disabled={true}
                            />
                        </Col>
                        <Col xs={12}>
                            <SelectOption
                                placeholder="Unit"
                                filter={true}
                                options={[
                                    { label: "ACRE", value: "acre" },
                                    { label: "Marla", value: "marla" },
                                    { label: "Kanal", value: "kanal" },
                                    { label: "Hectare", value: "hectare" },
                                ]}
                                value={{
                                    label: detail?.productDetails?.landArea?.unit?.toUpperCase(),
                                    value:
                                        detail?.productDetails
                                            ?.landArea?.unit,
                                }}
                                isDisabled={true}
                            />
                        </Col>

                    </Row>
                </Col>

                <Col className="gutter-row" xs={24}>
                    {/*Seed Treatment Start*/}
                    <Row gutter={[12, 12]}>
                        <Col xs={24}>
                            <div className="d-flex">
                                <label className="font-weight-bolder font-size-md">
                                    Seed Treatment
                                </label>
                            </div>

                            {detail?.productDetails?.seedTreatments?.map(
                                (seed, index) => {
                                    return (
                                        <div className="dosage-repeater mb-3" key={index.toString()}>
                                            <Row
                                                gutter={[10, 10]}
                                                className="align-items-center"
                                            >
                                                <Col
                                                    xs={5}
                                                    className="type"
                                                >
                                                    <ContentInputField
                                                        disabled={true}
                                                        name="Chemical Name"
                                                        value={seed?.chemical?.en}
                                                    />
                                                </Col>
                                                <Col xs={4}>
                                                    <ContentInputField
                                                        disabled={true}
                                                        name="Chemical Quantity"
                                                        value={seed?.chemicalQuantity}
                                                    />
                                                </Col>
                                                <Col xs={5}>
                                                    <SelectOption
                                                        isDisabled={true}
                                                        placeholder="Chemical Unit"

                                                        value={
                                                            seed?.chemicalQuantityUnit
                                                                ? {
                                                                    label:
                                                                        seed?.chemicalQuantityUnit,
                                                                    value:
                                                                        seed?.chemicalQuantityUnit,
                                                                }
                                                                : ""
                                                        }
                                                    />
                                                </Col>
                                                <Col xs={5}>
                                                    <ContentInputField
                                                        name="Seed Quantity"
                                                        disabled={true}
                                                        value={
                                                            seed?.seedQuantity
                                                                ? seed?.seedQuantity
                                                                : ""
                                                        }
                                                    />
                                                </Col>
                                                <Col xs={5}>
                                                    <ContentInputField
                                                        disabled={true}
                                                        name="Seed Unit"
                                                        value={seed?.seedQuantityUnit}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    );
                                }
                            )}
                        </Col>
                    </Row>
                    {/*Seed Treatment End*/}
                </Col>
            </Row>
        </>
    )
}

export default SeedDetail